import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn,BeforeInsert, BeforeUpdate} from "typeorm";

@Entity('conf_call')

export class ConfCallEntity {

    @PrimaryGeneratedColumn('increment',{name:'id'}) Id: number;
    
    @Column({
        type: 'varchar',
        nullable: true,
        length: '250',
        name: 'name',
    })
    meetingName: string;
    @Column({
        type: 'varchar',
        nullable: true,
        length: '500',
        name: 'admin_token',
    })
    adminToken: string;
    @Column({
        type: 'varchar',
        nullable: true,
        length: '500',
        name: 'user_token',
    })
    userToken: string;
    @Column({
        type: 'datetime',
        nullable: true,
        name: 'startTime'
    })
    startTime: Date;
    @Column({
        type: 'datetime',
        nullable: true,
        name: 'endTime',
    })
    endTime: Date;
    @Column({
        type: 'varchar',
        nullable: true,
        length: '500',
        name: 'meetingId',
    })
    meetingId: string;  
    @Column({
        type: 'int',
        nullable:true,
        name: 'admin_id'
    })
    adminId: number;
    @Column({
        type: 'text',
        nullable: true,
        name: 'description',
    })
    description: string;  
    @Column({
        type: 'text',
        nullable: true,
        name: 'url',
    })
    url: string; 
    @Column("boolean",{
        nullable:false,
        default:true,               
        name:"status"
    })
    status:boolean;
    @VersionColumn({
        default:1,
        name: "version_flag"
    })
    versionFlag: number;    
}